import qs from 'qs'

const fields = [
  'label'
]

export const queryJournalsTags = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      sort: ['sortKey:asc', 'label:asc'],
      pagination: {
        limit: -1
      },
      filters: {
        journalEntries: {
          id: {
            $notNull: true
          }
        }
      },
      fields: fields,
      populate: {
        journalEntries: {
          fields: ['id']
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `journal-tags?${query}`
}
